import React from 'react';
import { IconProps } from '.';

const SvgLoadingDonuts = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      color={color}
      viewBox='0 0 50 50'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M43.935 25.145c0-10.318-8.364-18.683-18.683-18.683-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615s14.615 6.543 14.615 14.615h4.068z'
      >
        <animateTransform
          attributeName='transform'
          attributeType='xml'
          dur='0.6s'
          from='0 25 25'
          repeatCount='indefinite'
          to='360 25 25'
          type='rotate'
        />
      </path>
    </svg>
  );
};

export default SvgLoadingDonuts;
